// Politique de sponsoring.
//
// ⚛️ ÉCRAN MIGRÉ VERS REACT. Le contenu vit maintenant dans
// js/react/ecrans/Sponsoring.jsx ; ce fichier n'est plus qu'un adaptateur, pour
// que le routeur de app.js n'ait pas à savoir qui rend quoi.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Sponsoring from "../react/ecrans/Sponsoring.jsx";

export const rendre = vueReact(Sponsoring);
